import { type PRProductSupported } from '@/domains/core/tracking/interfaces/PRProductSupported';
import { type Product as AlgoliaProduct } from '@/domains/productDiscovery/Recommendation/interfaces/product';

export const algoliaProductToPrProductMapper = (
  p: AlgoliaProduct,
  itemIndex: number,
): PRProductSupported => {
  return {
    pr_article_id: p.articleId,
    pr_model_id: p.modelId,
    pr_product_id: parseInt(p.productId),
    pr_seller_id: p.sellerId,
    pr_brand_id: p.brandId,
    pr_lowest_category_id: p.categoriesLastId,
    pr_name: p.title,
    pr_price: p.price,
    pr_price_excluding_vat: p.bundlePrices?.without_vat,
    pr_is_sponsored: !!p.isSponsored,
    pr_is_mf: p.isMmf,
    pr_position: itemIndex + 1,
    pr_quantity: undefined,
    pr_category_level_name_1: p.categoriesL0?.at(0),
    pr_category_level_name_2: p.categoriesL1.at(0),
    pr_category_level_name_3: p.categoriesL2.at(0),
    pr_category_level_name_4: p.categoriesL3?.at(0),
    pr_category_level_id_1: p.categoriesL0Id.at(0),
    pr_category_level_id_2: p.categoriesL1Id.at(0),
    pr_category_level_id_3: p.categoriesL2Id.at(0),
    pr_category_level_id_4: p.categoriesL3Id?.at(0),
    pr_brand_name: p.brandName,
    pr_has_a_coupon: !!p.coupon || p.hasBulk,
    pr_rating_count: p.rating,
    pr_rating: p.rating,
    pr_variant_count: p.modelsCount,
    pr_is_second_hand_product: p.isSecondHand,
    pr_shipping_options: undefined,
    pr_b2b_price_advantage_count: undefined,
    pr_md_count: undefined,
    pr_is_best_quality_offer: undefined,
    pr_label: undefined,
    pr_total_ati: undefined,
  };
};
